import axiosInstance from '../../utils/axiosConfig'; 
export const GET_PAYMENT = "GET_PAYMENT";
export const CREATE_PAYMENT = "CREATE_PAYMENT";
export const DELETE_PAYMENT = "DELETE_PAYMENT";
export const UPDATE_PAYMENT = "UPDATE_PAYMENT";


export function getAllPayments() {
  return async (dispatch) =>
      await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_CLAIM}/payment/filter`, {})
      .then((response) => {
        
        dispatch({
          type: GET_PAYMENT,
          payload: response.data  ,

        });
      })
      .catch((error) => {
         
        console.log("error", error);
      });
}


export async function filterPayment(claimNumber) {
  try {
    const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_CLAIM}/payment/filter`, {
      associatedClaim: claimNumber,
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching Payment details: ${error.message}`);
  }
}

export async function updatePaymentInspector(paymentInspector) {
  try {
    const response = await axiosInstance.put(`${process.env.REACT_APP_BACKEND_URL_MS_CLAIM}/paymentInspector/update/${paymentInspector._id}`, paymentInspector );
    return response.data;
  } catch (error) {
    console.error(`Error fetching Payment details: ${error.message}`);
  }
}

export async function updatePaymentGarage(paymentGarage) {
  try {
    const response = await axiosInstance.put(`${process.env.REACT_APP_BACKEND_URL_MS_CLAIM}/paymentRepair/update/${paymentGarage._id}`, paymentGarage );
    return response.data;
  } catch (error) {
    console.error(`Error fetching Payment details: ${error.message}`);
  }
}

export function updatePaymentStatus(idPayment, Status , motifPI) {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.put(
        `${process.env.REACT_APP_BACKEND_URL_MS_CLAIM}/payment/updateStatus/${idPayment}`,
        {
          status: Status ,
          ...(Status === "PIKO" && { motifPI :motifPI })
        }
      );
      dispatch({
        type: UPDATE_PAYMENT,
        payload: response.data
      });
    } catch (error) {
      console.log("error", error);
    }
  };
}

